import { render, staticRenderFns } from "./viewerBIMModel.vue?vue&type=template&id=9abb0f58&scoped=true"
import script from "./viewerBIMModel.vue?vue&type=script&lang=js"
export * from "./viewerBIMModel.vue?vue&type=script&lang=js"
import style0 from "./viewerBIMModel.vue?vue&type=style&index=0&id=9abb0f58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abb0f58",
  null
  
)

export default component.exports